// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"8c3ac676","84":"6e4ad715","231":"6d75205c","253":"ef25bf93","453":"87b9c746","501":"6ef9f4de","516":"e4dc84f8","605":"41ecbee2","712":"1be10e80","761":"db257de1","905":"a6088cfd"}[chunkId] + ".chunk.js";
};